import React, { useEffect, useState } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useStyles } from './styles';
import { capitalizeFirstLetter } from '../../Utils/global.utils';

export function BookTexField({
  name,
  label,
  placeholder,
  formik,
  type,
  onChange = false,
  onBlur,
  select,
  selectOptions,
  defaultValue,
  value,
  multiline = false,
  rows = 0,
}) {
  const detectDirection = (text) => {
    const urduRegex = /[\u0600-\u06FF]/;
    return urduRegex.test(text) ? 'rtl' : 'ltr';
  }
  const classes = useStyles();
  return select ? (
    <TextField
      name={name}
      className={classes.textField}
      value={formik ? formik.values[name] : value}
      label={label}
      type={type ? type : 'text'}
      placeholder={placeholder}
      variant='outlined'
      onChange={
        onChange ? (e) => onChange(e, formik) :
          formik && formik.handleChange
      }
      error={formik && formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik && formik.touched[name] && formik.errors[name]}
      onBlur={onBlur && onBlur}
      select
    >
      {selectOptions &&
        selectOptions.map((option, index) => (
          <MenuItem key={1 + index} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
    </TextField>
  ) : (
    <TextField
      name={name}
      className={classes.textField}
      value={formik?.values[name]}
      label={label}
      type={type ? type : 'text'}
      placeholder={placeholder || ''}
      variant='outlined'
      onChange={
        formik && formik.handleChange
          ? formik.handleChange
          : onChange && onChange
      }
      error={formik && formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik && formik.touched[name] && formik.errors[name]}
      onBlur={onBlur && onBlur}
      multiline={multiline}
      rows={rows}
      InputProps={{
        sx: {
          fontFamily: 'JameelNoori',
          fontSize: '20px',
          direction: detectDirection(formik?.values[name]),
          lineHeight: 2,
        },
      }}
    />
  );
}

